var exports = {
  "F9": "PremiumHalo.module__halo___VzZXOD",
  "EX": "PremiumHalo.module__small___VzZXOD",
  "ys": "PremiumHalo.module__glow___VzZXOD",
  "HZ": "PremiumHalo.module__premiumHaloLeft___VzZXOD",
  "AA": "PremiumHalo.module__premiumHaloRight___VzZXOD",
};

module.exports = exports;
